import type {User} from '@local/redux/state/user';

export class UserHolder {
  static user?: User;

  /**
   * サインアップ -> 成功画面 -> ボタン押して遷移 という動作をしたいためだけに配置。遷移時にこのフィールドは消す。
   */
  static custom_token?: string;
}
